export class AnalyticsData {

   UserID : string;
   UserProfile : string;
   CompanyID : string ;
   CompanyUID: string;
   Webapp : string = 'Spectrum';
   Service : string = 'Spectrum';
   PageType : string;
   event : string = 'viewContent';
   Region: string[]=[];
   country: string = '';
   bandGroup: string = '';
   band: string = '';
   uri : string;
   title: string;
   nonAuthorisedAccess : boolean =false;
  constructor(

  ) {}

  toJson() {
    return {
      'UserID':this.UserID,
      'UserProfile':this.UserProfile,
      'CompanyID':this.CompanyID,
      'CompanyUID':this.CompanyUID,
      'Webapp':this.Webapp,
      'Service':this.Service,
      'PageType':this.PageType,
      'event':this.event,
      'Region':this.Region.join(),
      'country':this.country,
      'bandGroup': this.bandGroup,
      'band': this.band,
      'uri':this.uri,
      'title':this.title,
      'nonAuthorisedAccess':this.nonAuthorisedAccess
     };
  }

}
